import { Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';

interface QuestionOption {
    value: string;
    label: string;
}

interface QuestionProps {
    question: string;
    value: string | null;
    onChange: (value: string) => void;
    options?: QuestionOption[];
    helperText?: string;
}

export default function Question({
    question,
    value,
    onChange,
    options = undefined,
    helperText = undefined,
}: Readonly<QuestionProps>) {
    // Default to yes/no options if no custom options provided
    const defaultOptions: QuestionOption[] = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const questionOptions = options || defaultOptions;

    return (
        <Box sx={{ width: '100%' }}>
            <FormControl component="fieldset" sx={{ width: '100%' }}>
                <Typography
                    variant="body1"
                    color="text.primary"
                    sx={{
                        fontWeight: 500,
                        mb: 2,
                    }}>
                    {question}
                </Typography>
                {helperText && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {helperText}
                    </Typography>
                )}
                <RadioGroup value={value || ''} onChange={(e) => onChange(e.target.value)} sx={{ width: '100%' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1.5,
                            width: '100%',
                        }}>
                        {questionOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={
                                    <Radio
                                        sx={{
                                            color: 'text.secondary',
                                            '&.Mui-checked': {
                                                color: 'primary.main',
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <Typography variant="body1" color="text.primary">
                                        {option.label}
                                    </Typography>
                                }
                                sx={{
                                    flex: 1,
                                    margin: 0,
                                    padding: '12px',
                                    borderStyle: 'solid',
                                    borderWidth: value === option.value ? 2 : 1,
                                    borderColor: value === option.value ? 'secondary.main' : 'grey.300',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor: 'cement.main',
                                    },
                                }}
                            />
                        ))}
                    </Box>
                </RadioGroup>
            </FormControl>
        </Box>
    );
}
